import { FormBuilder, FormGroup, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import * as dayjs from 'dayjs';
import { ngbDateToFormat } from '../../../utils/utils';


export class FlightsDiversionFormBuilder {

  static constructForm(fb: FormBuilder, dateFormat: string): FormGroup {

    return fb.group({
      etaDate: [''],
      etaTime: [''],
      airport: [''] , 
      si: [''],
      std: ['']
    }, 
    //{validator: this.etdMustNotBeSameOrBeforeThanStdValidation(dateFormat)}
    );
  }

  static etdMustNotBeSameOrBeforeThanStdValidation(dateFormat: string): ValidatorFn {
    return (group: FormGroup): ValidationErrors | null => {
      if (!group || !group.value || !group.value.etdDate || !group.value.etdTime || !group.value.std) {
        return {invalidEtd: true};
      }

      const val = group.value;

      const stdMoment = dayjs.utc(val.std);
      const etdMoment = dayjs.utc(ngbDateToFormat(val.etdDate, dateFormat) + '-' + val.etdTime, dateFormat + '-HH:mm');

      return stdMoment.isValid() && etdMoment.isValid() ?
        null : {invalidEtd: true};
    };
  }
}
